<template>
    <el-dialog title="申请售后" width="30%" center :visible.sync="dialogVisible">
        <div class="dialog-content">
            <div>请选择下列售后缘由，便于客服快速为您解答订单疑虑（可多选）</div>
            <div class="service-type" :class="{'active': service_select.includes(item.value)}" v-for="(item, index) in service_list" :key="index" @click="changeService(item.value)"> {{ item.label }} </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :loading="loading" @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { clientSubmitAfterSafes } from "@/api/request";

export default {
    props: {
        clientSubmitAfterSafesData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            service_list: [
				{label: '价格疑异', value: '价格疑异'},
				{label: '实验时长不符', value: '实验时长不符'},
				{label: '样品数量不符', value: '样品数量不符'},
				{label: '实验数据缺失', value: '实验数据缺失'},
				{label: '申请复测', value: '申请复测'},
			],
			service_select: []
        }
    },
    methods: {
        open() {
            this.dialogVisible = true
        },
        close() {
            this.service_select = []
			this.dialogVisible = false
		},
        changeService(value) {
			const index = this.service_select.findIndex(item => item == value)
			if(index == -1) {
				this.service_select.push(value)
			}else {
				this.service_select.splice(index, 1)
			}
		},
        confirm() {
            if(!this.service_select.length) {
                this.$message.warning('请选择售后类型')
				return
			}
			this.loading = true
			const data = this.clientSubmitAfterSafesData
			data.afterSalesDesc = this.service_select.join(',')
            clientSubmitAfterSafes(data).then(() => {
				this.close()
                this.$message.success("售后服务申请成功！")
				this.$emit('refesh')
			    this.loading = false
            }).catch(() => {
			    this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.service-type {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 80%;
	height: 50px;
	margin-top: 10px;
	color: #5D5D5D;
	border-radius: 12px;
	border: 1px solid #E8E8E8;
}
.active {
	font-weight: 600;
	color: #5CC300;
	border: 1px solid #5CC300;
	background-color: #5CC30010;
}
.dialog-footer {
    display: flex;
    justify-content: space-around;
    width: 80%;
    margin: 0 auto;
}
</style>